/* eslint-disable max-len */
import { AccountType } from '../../../shared/Constants';

export const userHasOwnerRole = (userRole) => userRole === 'owner' || userRole === 'nbm-owner';

export const userCanUpdateCompanyData = (userRole) =>
  userRole === 'super-admin' ||
  userRole === 'owner' ||
  userRole === 'nbm-owner' ||
  userRole === 'admin' ||
  userRole === 'nbm-admin' ||
  userRole === 'external-support' ||
  userRole === 'nbm-external-support';

export const userHasMemberRole = (userRole) => userRole === 'member' || userRole === 'nbm-member';

export const userHasItemBankAdminRole = (userRole) => userRole === 'itembank-admin';

export const userHasSuperAdminRole = (userRole) => userRole === 'super-admin';

export const accountTypeIsClient = (accountType) =>
  accountType === AccountType.CLIENT || accountType === AccountType.NBM_CLIENT || accountType === AccountType.ESSENTIAL;

export const accountTypeIsTopLevel = (accountType) =>
  accountType === AccountType.GSC || accountType === AccountType.MCP || accountType === AccountType.GPI;

export const accountTypeIsGPI = (accountType) => accountType === AccountType.GPI;

export const accountIsMCP = (accountType) => accountType === AccountType.MCP;

export const accountIsGP = (accountType) => accountType === AccountType.GP;
